// extracted by mini-css-extract-plugin
module.exports = {"saveObjectDrawer":"SaveObjectDrawer_saveObjectDrawer__3234x","content":"SaveObjectDrawer_content__2W_ho"};